(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aim-product-lightbox"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('aim-product-lightbox')) return;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  let activeViewer;
  class AimProductLightbox extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      this.stage = this.querySelector('.aim-lightbox__stage');
      this.image = this.querySelector('.aim-lightbox__image');
      this.thumbs = [...this.querySelectorAll('[data-media-id]')];
      this.points = new Map();
      this.querySelector('.aim-lightbox__close').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('.aim-lightbox__prev').addEventListener('click', () => this.select(this.index - 1), options);
      this.querySelector('.aim-lightbox__next').addEventListener('click', () => this.select(this.index + 1), options);
      this.thumbs.forEach((button, i) => button.addEventListener('click', () => this.select(i), options));
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); event.stopPropagation(); this.select(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, options);
      this.stage.addEventListener('pointerdown', (event) => this.down(event), options);
      this.stage.addEventListener('pointermove', (event) => this.move(event), options);
      this.stage.addEventListener('pointerup', (event) => this.up(event), options);
      this.stage.addEventListener('pointercancel', (event) => { this.points.delete(event.pointerId); this.gesture = null; }, options);
      window.addEventListener('resize', () => { if (this.dialog.open) { this.scale = 1; this.x = this.y = 0; this.fit(); } }, options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restore(); this.abort?.abort(); this.abort = null;
    }
    open(id, trigger, pointerOpened = false) {
      const index = this.thumbs.findIndex(button => button.dataset.mediaId === id);
      if (index < 0 || this.dialog.open) return;
      activeViewer?.dialog.close();
      activeViewer?.restore();
      activeViewer = this;
      this.trigger = trigger;
      if (pointerOpened) trigger.setAttribute('data-aim-pointer-return', '');
      else trigger.removeAttribute('data-aim-pointer-return');
      this.scroll = { x: window.scrollX, y: window.scrollY };
      this.saved = ['position','top','left','width','overflow'].map(key => [key, document.body.style.getPropertyValue(key), document.body.style.getPropertyPriority(key)]);
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scroll.y}px`;
      document.body.style.left = `-${this.scroll.x}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      this.select(index);
      this.querySelector('.aim-lightbox__close').focus({ preventScroll: true });
    }
    restore() {
      if (!this.saved) return;
      this.imageRequest = (this.imageRequest || 0) + 1;
      this.saved.forEach(([key, value, priority]) => {
        if (value) document.body.style.setProperty(key, value, priority);
        else document.body.style.removeProperty(key);
      });
      this.saved = null;
      window.scrollTo({ left: this.scroll.x, top: this.scroll.y, behavior: 'instant' });
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      if (activeViewer === this) activeViewer = null;
      this.points.clear();
    }
    select(index) {
      this.index = (index + this.thumbs.length) % this.thumbs.length;
      const current = this.thumbs[this.index];
      this.scale = 1; this.x = this.y = 0; this.gesture = null; this.points.clear();
      const request = this.imageRequest = (this.imageRequest || 0) + 1;
      const thumbnail = current.querySelector('img');
      const preview = document.createElement('img');
      preview.className = 'aim-lightbox__image';
      preview.alt = current.dataset.imageAlt;
      preview.draggable = false;
      preview.src = thumbnail.currentSrc || thumbnail.src;
      this.image.replaceWith(preview);
      this.image = preview;
      const fullImage = new Image();
      fullImage.className = 'aim-lightbox__image';
      fullImage.alt = current.dataset.imageAlt;
      fullImage.draggable = false;
      fullImage.onload = async () => {
        try { if (fullImage.decode) await fullImage.decode(); } catch { return; }
        if (request !== this.imageRequest || !this.dialog.open || !this.isConnected) return;
        fullImage.setAttribute('style', this.image.getAttribute('style') || '');
        this.image.replaceWith(fullImage);
        this.image = fullImage;
      };
      fullImage.src = current.dataset.imageUrl;
      this.thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
      const strip = current.parentElement;
      strip.scrollTo({ left: current.offsetLeft - (strip.clientWidth - current.offsetWidth) / 2, behavior: 'instant' });
      this.querySelector('.aim-lightbox__status').textContent = `${this.index + 1} / ${this.thumbs.length}: ${current.dataset.imageAlt}`;
      this.fit();
      if (this.thumbs.length > 1) {
        const next = new Image(); next.src = this.thumbs[(this.index + 1) % this.thumbs.length].dataset.imageUrl;
      }
    }
    fit() {
      const data = this.thumbs[this.index].dataset;
      const width = Number(data.imageWidth) || 1, height = Number(data.imageHeight) || 1;
      const ratio = Math.min(this.stage.clientWidth / width, this.stage.clientHeight / height, 1);
      this.baseWidth = width * ratio; this.baseHeight = height * ratio;
      this.maxScale = Math.max(1, Math.min(4, 1 / ratio));
      this.image.style.width = `${this.baseWidth}px`; this.image.style.height = `${this.baseHeight}px`;
      this.paint();
    }
    paint() {
      const maxX = Math.max(0, (this.baseWidth * this.scale - this.stage.clientWidth) / 2);
      const maxY = Math.max(0, (this.baseHeight * this.scale - this.stage.clientHeight) / 2);
      this.x = clamp(this.x, -maxX, maxX); this.y = clamp(this.y, -maxY, maxY);
      this.image.style.transform = `translate3d(${this.x}px, ${this.y}px, 0) scale(${this.scale})`;
      this.dialog.classList.toggle('is-zoomed', this.scale > 1.01);
    }
    down(event) {
      if (event.button !== 0) return;
      this.stage.setPointerCapture(event.pointerId);
      this.points.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (this.points.size === 1) this.gesture = { x: event.clientX, y: event.clientY, panX: this.x, panY: this.y, scale: this.scale, moved: false, pinched: false };
      if (this.points.size === 2 && this.gesture) {
        const [a,b] = [...this.points.values()];
        this.gesture.pinched = true; this.gesture.distance = Math.hypot(a.x-b.x,a.y-b.y); this.gesture.scale = this.scale;
      }
    }
    move(event) {
      if (!this.points.has(event.pointerId)) {
        if (event.pointerType === 'mouse' && this.scale > 1) {
          this.x = (.5 - event.clientX / this.stage.clientWidth) * Math.max(0,this.baseWidth*this.scale-this.stage.clientWidth);
          this.y = (.5 - event.clientY / this.stage.clientHeight) * Math.max(0,this.baseHeight*this.scale-this.stage.clientHeight);
          this.paint();
        }
        return;
      }
      this.points.set(event.pointerId, { x: event.clientX, y: event.clientY });
      const gesture = this.gesture; if (!gesture) return;
      if (this.points.size === 2) {
        const [a,b] = [...this.points.values()];
        this.scale = clamp(gesture.scale * Math.hypot(a.x-b.x,a.y-b.y) / Math.max(1,gesture.distance), 1,this.maxScale);
        this.paint(); return;
      }
      const dx = event.clientX-gesture.x, dy = event.clientY-gesture.y;
      if (Math.hypot(dx,dy)>8) gesture.moved = true;
      if (this.scale > 1 && !gesture.pinched) { this.x = gesture.panX+dx; this.y = gesture.panY+dy; this.paint(); }
    }
    up(event) {
      this.points.delete(event.pointerId);
      const gesture = this.gesture;
      if (!gesture || this.points.size) return;
      this.gesture = null;
      if (gesture.pinched) return;
      const dx = event.clientX-gesture.x, dy = event.clientY-gesture.y;
      if (gesture.moved) {
        if (gesture.scale <= 1.01 && Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.3) this.select(this.index+(dx<0 ? 1 : -1));
        return;
      }
      if (event.pointerType !== 'mouse') return;
      this.scale = this.scale > 1.01 ? 1 : this.maxScale;
      this.x = (this.stage.clientWidth/2-event.clientX)*(this.scale-1);
      this.y = (this.stage.clientHeight/2-event.clientY)*(this.scale-1);
      this.paint();
    }
  }
  customElements.define('aim-product-lightbox', AimProductLightbox);
  let press;
  window.addEventListener('keydown', event => {
    if (event.key === 'Tab') {
      document.querySelectorAll('[data-aim-pointer-return]').forEach(trigger => trigger.removeAttribute('data-aim-pointer-return'));
    }
  }, true);
  window.addEventListener('pointerdown', event => {
    const trigger = event.target.closest?.('[data-aim-lightbox-open]');
    press = trigger ? { trigger, x:event.clientX, y:event.clientY, moved:false } : null;
  }, true);
  window.addEventListener('pointermove', event => {
    if (press && Math.hypot(event.clientX-press.x,event.clientY-press.y)>8) press.moved = true;
  }, true);
  window.addEventListener('pointercancel', () => { if (press) press.moved = true; }, true);
  window.addEventListener('click', event => {
    const trigger = event.target.closest?.('[data-aim-lightbox-open]');
    if (!trigger) return;
    const viewer = trigger.closest('media-gallery')?.querySelector('aim-product-lightbox');
    if (!viewer) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!(event.detail && press?.trigger === trigger && press.moved)) viewer.open(trigger.dataset.aimLightboxOpen, trigger, event.detail > 0);
    press = null;
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
